import { cva } from 'class-variance-authority';

export const root = cva(['col-span-full', 'gap-4', 'animate-pulse']);

export const item = cva(['gap-4', 'bg-neutral-400', 'flex', 'grow', 'mt-2'], {
  variants: {
    intent: {
      circle: ['rounded-full', 'mx-2', 'first:ml-0'],
      text: [],
    },
    width: {
      full: ['w-full'],
      xs: ['w-1/6', 'grow-0'],
      sm: ['w-1/5', 'grow-0'],
      md: ['w-2/3'],
      lg: ['w-4/5'],
      custom: [],
    },
    size: {
      full: ['h-full'],
      sm: ['h-4'],
      md: ['h-6'],
      lg: ['h-8'],
      xl: ['h-12'],
    },
  },
  compoundVariants: [
    {
      intent: 'circle',
      size: 'sm',
      className: ['h-4 w-4 grow-0'],
    },
    {
      intent: 'circle',
      size: 'md',
      className: ['h-8 w-8 grow-0'],
    },
    {
      intent: 'circle',
      size: 'lg',
      className: ['h-8 w-8 grow-0'],
    },
    {
      intent: 'circle',
      size: 'xl',
      className: ['h-12 w-12 grow-0'],
    },
  ],
  defaultVariants: {
    intent: 'text',
    size: 'md',
    width: 'full',
  },
});
